if (!customElements.get("corridge-newsletter")) {
  customElements.define("corridge-newsletter", class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const form = this.querySelector("form");
      const button = form.querySelector("button[type=submit]");
      const status = this.querySelector("[data-newsletter-status]");
      const radios = [...form.querySelectorAll("input[name=discount]")];
      const companyId = this.dataset.companyId;
      const listId = this.dataset.listId;
      const customSource = this.dataset.customSource || "Corridge footer";
      const validId = (id) => /^[a-zA-Z0-9]{6}$/.test(id || "");
      const configured = validId(companyId) && validId(listId);
      const message = (text) => {
        status.textContent = text;
        status.hidden = false;
      };
      button.disabled = !configured;
      button.classList.remove("ds-btn--disabled");
      let submitting = false;
      form.addEventListener("submit", async (event) => {
        event.preventDefault();
        if (!configured || submitting || !form.reportValidity()) return;
        const selected = radios.find((radio) => radio.checked);
        if (radios.length && !selected) return;
        submitting = true;
        button.disabled = true;
        form.setAttribute("aria-busy", "true");
        radios.forEach((radio) => { radio.disabled = true; });
        status.hidden = true;
        try {
          const profileAttributes = {
            email: form.elements.email.value.trim(),
            subscriptions: { email: { marketing: { consent: "SUBSCRIBED" } } }
          };
          const firstName = form.elements.first_name?.value.trim();
          if (firstName) profileAttributes.first_name = firstName;
          if (selected) profileAttributes.properties = { discount: selected.value };

          const response = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(companyId)}`, {
            method: "POST",
            headers: {
              "Content-Type": "application/vnd.api+json",
              "Accept": "application/vnd.api+json",
              "revision": "2025-07-15"
            },
            body: JSON.stringify({
              data: {
                type: "subscription",
                attributes: {
                  custom_source: customSource,
                  profile: { data: {
                    type: "profile",
                    attributes: profileAttributes
                  } }
                },
                relationships: { list: { data: { type: "list", id: listId } } }
              }
            })
          });
          if (!response.ok) throw new Error("Subscription request failed");
          message("Vielen Dank! Falls du eine Bestätigungs-E-Mail erhältst, bestätige bitte deine Anmeldung. Schau auch im Spam-Ordner nach.");
          // Clear personal fields while preserving the offer that was submitted.
          form.elements.email.value = "";
          if (form.elements.first_name) form.elements.first_name.value = "";
        } catch {
          message("Die Anmeldung konnte nicht abgeschlossen werden. Bitte versuche es erneut.");
        } finally {
          submitting = false;
          button.disabled = false;
          radios.forEach((radio) => { radio.disabled = false; });
          form.removeAttribute("aria-busy");
        }
      });
    }
  });
}
